import {
  Box,
  Button as MuiButton,
  styled,
  CircularProgress,
} from "@mui/material";
import { useSnackbar } from "notistack";

import { Modal } from "components/Modal";
import { Typography } from "components/Typography";
import { useUpdateFlaggedAccountMutation } from "api/blacklist";

import { ACCOUNT_FLAG_STATUS_TYPES } from "../FlaggedAccounts";

const Button = styled(MuiButton)(() => ({
  textTransform: "capitalize",
  marginRight: 2,
  boxShadow: "none",
  fontWeight: "400",
  marginTop: "20px",
  "&:hover": { backgroundColor: "#2D75B6", boxShadow: "none" },
}));

export const UpdateFlaggedAccountStatus = ({ open, account, handleClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const {
    mutate: updateStatus,
    isPending,
    reset,
  } = useUpdateFlaggedAccountMutation();

  const isFlagged =
    parseInt(account?.status) === ACCOUNT_FLAG_STATUS_TYPES.FLAGGED;

  const closeModal = () => {
    handleClose();
    reset();
  };

  const handleSubmit = () => {
    updateStatus(
      {
        data: {
          blacklistId: account?.blacklistId,
          status: !isFlagged,
        },
      },
      {
        onSuccess: () => {
          const successText = isFlagged
            ? "Restricions on account removed succesfully"
            : "Account restricted succesfully ";
          enqueueSnackbar(successText, { variant: "success" });
          closeModal();
        },
        onError: (error) => {
          enqueueSnackbar(error.message, { variant: "error" });
        },
      }
    );
  };

  const alertTitle = isFlagged
    ? "Are you sure you want to remove restriction on this account?"
    : "Are you sure you want to flag this account?";

  return (
    <Box>
      <Modal open={open} handleClose={closeModal}>
        <Typography
          variant="emailHeading"
          align="center"
          component="h2"
          sx={{ fontSize: "20px", mb: "15px" }}
        >
          {alertTitle}
        </Typography>
        <Box my={0.8} display="flex" flexDirection="column" gap={0.8}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={0.5}
          >
            <Typography>Account Name:</Typography>
            <Typography
              variant="loginLabel"
              component="h6"
              sx={{ fontSize: 14 }}
            >
              {account?.name}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap={0.5}
          >
            <Typography>Account Number:</Typography>
            <Typography
              variant="loginLabel"
              component="h6"
              sx={{ fontSize: 14 }}
            >
              {account?.code}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap={0.5}
          >
            <Typography>Bank:</Typography>
            <Typography
              variant="loginLabel"
              component="h6"
              sx={{ fontSize: 14 }}
            >
              {account?.meta?.account?.bankName}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" gap={3}>
          <Box flex={1}>
            <Button
              variant="outlined"
              fullWidth
              disableRipple
              onClick={closeModal}
              sx={{
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
            >
              No, cancel
            </Button>
          </Box>
          <Box flex={1}>
            <Button
              variant="contained"
              fullWidth
              disableRipple
              onClick={handleSubmit}
              sx={{ gap: 1 }}
            >
              <span>Yes, {isFlagged ? "Remove" : "Flag"}</span>
              {isPending && (
                <CircularProgress size={18} sx={{ color: "#fff" }} />
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
